const typeCompany = (preRegistration) => {
  const statuses = {
    TRIAL_LIMITED: 'Trial',
    TRIAL_COMPLETE: 'Trial',
    TRIAL_CANCELLED: 'Trial',
  }

  const kinded = {
    T: 'Template',
    S: 'Fornecedora',
    C: 'Real (Jurídica)',
    P: 'Real (Física)',
  }

  return statuses[preRegistration?.status] || kinded[preRegistration?.kind]
}

export default typeCompany
